var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            .cls-1{fill:#ccd9a9;}.cls-2{fill:none;stroke:#292566;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2.2px;}\n        ")),React.createElement("line",{"className":"cls-2","x1":"8.63","y1":"11.08","x2":"22.72","y2":"11.08","key":1}),React.createElement("line",{"className":"cls-2","x1":"8.63","y1":"15.55","x2":"18.69","y2":"15.55","key":2}),React.createElement("line",{"className":"cls-2","x1":"8.63","y1":"20.02","x2":"14.82","y2":"20.02","key":3})]);
}

Burger.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = Burger;

Burger.default = Burger;
